/**
 * number to a hex value in the range [00, ff]
 * @param value
 * @returns {string}
 */
export function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}